import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="bg-navy text-white pt-12 pb-16 px-4 flex flex-col items-center text-center" data-id="element-114">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="max-w-[720px] w-full flex flex-col items-center" data-id="element-115">
        <span className="inline-block bg-white/10 text-white/90 text-xs font-bold px-3 py-1 rounded-full mb-6 border border-white/20 uppercase tracking-wide" data-id="element-116">
          🇦🇷 Sistema Completo · Edición 2026
        </span>

        <h1 className="text-[32px] md:text-5xl font-extrabold leading-tight mb-4 tracking-tight" data-id="element-117">
          Dejá de perder plata.
          <br data-id="element-118" />
          <span className="text-emerald" data-id="element-119">Empezá a moverla.</span>
        </h1>

        <p className="text-[15px] md:text-lg text-white/80 leading-[1.6] mb-8 max-w-[500px]" data-id="element-120">
          El sistema paso a paso para ahorrar, invertir y construir patrimonio
          real desde un sueldo argentino.
        </p>

        <div className="w-full max-w-[400px] mb-10" data-id="element-121">
          <img src="https://cdn.magicpatterns.com/uploads/v2ymhgyK6MfmuEYmgEEr6V/MOCK_UP_EL_COSTO_DE_NO_HACER_NADA.png" alt="El Costo de No Hacer Nada - Mockup del producto" className="w-full h-auto drop-shadow-2xl" data-id="element-122" />
        </div>

        <div className="w-full max-w-[400px] flex flex-col gap-3 mb-8" data-id="element-123">
          <a href="#pricing" className="w-full h-[56px] bg-gold text-navy font-bold text-[18px] rounded-xl flex items-center justify-center shadow-[0_4px_14px_0_rgba(186,117,23,0.39)] hover:bg-gold-600 transition-colors" data-id="element-124">
            💰 Quiero El Costo de No Hacer Nada
          </a>
          <a href="#tomos" className="w-full h-[56px] bg-transparent border-2 border-white/20 text-white font-bold text-[16px] rounded-xl flex items-center justify-center hover:bg-white/5 transition-colors" data-id="element-125">
            Ver qué incluye ↓
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-white/60 font-medium" data-id="element-126">
          <span data-id="element-127">⭐ 4.9/5</span>
          <span data-id="element-128">·</span>
          <span data-id="element-129">+200 personas</span>
          <span data-id="element-130">·</span>
          <span data-id="element-131">📦 140 páginas</span>
          <span data-id="element-132">·</span>
          <span data-id="element-133">🔒 Garantía 7 días</span>
        </div>
      </motion.div>
    </section>;
}